module.exports = __webpack_public_path__ + "img/loading.0c34f9f4.png";